/*!

=========================================================
* Now UI Dashboard PRO React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard/Dashboard.js";
import LoginPage from "views/Pages/LoginPage.js";
import RegisterPage from "views/Pages/RegisterPage.js";
import OnboardingPage from "views/Onboarding/OnboardingPage";
import OnboardingBasic from "views/Onboarding/OnboardingBasic";
import OnboardingBusiness from "views/Onboarding/OnboardingBusiness";
import SpendingControls from "views/SpendingControls/SpendingControls";
import Account from "views/Account/Account";
import Publishers from "views/Publishers/Publishers";
import ResetPasswordPage from "views/Account/ResetPasswordPage";
import ProfilePage from "views/Account/ProfilePage";

let routes = [
  {
    path: "/login",
    name: "Streempay Login",
    icon: "now-ui-icons objects_key-25",
    component: LoginPage,
    layout: "/auth",
  },
  {
    path: "/start",
    name: "Streempay Onboarding",
    icon: "now-ui-icons objects_key-25",
    component: OnboardingPage,
    layout: "/onboarding",
  },
  {
    path: "/basic",
    name: "Streempay Basic Onboarding",
    icon: "now-ui-icons objects_key-25",
    component: OnboardingBasic,
    layout: "/onboarding",
  },
  {
    path: "/business",
    name: "Streempay Business Onboarding",
    icon: "now-ui-icons objects_key-25",
    component: OnboardingBusiness,
    layout: "/onboarding",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "now-ui-icons business_chart-bar-32",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/spending-controls",
    name: "Spending Notifications",
    icon: "now-ui-icons ui-1_bell-53",
    component: SpendingControls,
    layout: "/admin",
  },
  {
    path: "/publishers",
    name: "Publishers",
    icon: "now-ui-icons education_paper",
    component: Publishers,
    layout: "/admin",
  },
  {
    path: "/account",
    name: "Account",
    icon: "now-ui-icons loader_gear",
    component: Account,
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "Profile",
    icon: "now-ui-icons design_app",
    component: ProfilePage,
    layout: "/admin",
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    icon: "now-ui-icons design_app",
    component: ResetPasswordPage,
    layout: "/admin",
  },
  {
    path: "/signup",
    name: "Streempay Signup",
    icon: "now-ui-icons objects_key-25",
    component: RegisterPage,
    layout: "/auth",
  }
];

export default routes;
